import React, { Component } from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, Form, NavLink, Input, Table } from 'reactstrap';
import { Link, Redirect } from 'react-router-dom';
import '../../../custom.css'
import '../../../style-new.css'
import axios from 'axios';
import { toast } from 'react-toastify';
//import MyModal from './../../CustomModal/CustomModal';

export class ManufacturerAnalysis extends Component {

    constructor(props) {
        super(props);

        this.initialState = {
            loading: true,
            patientactivities: [],
            patientId: "",
            patientAccessionId: "",
            title: "",
            description: "",
            // authError: false,
            error: '',
            errorType: ''
        };
        this.state = this.initialState;

    }

    ////modal close button event
    //handleModalClose = () => {
    //    this.setState({
    //        modal: false,
    //        modalTitle: '',
    //        modalBody: ''
    //    });
    //}

    componentDidMount() {
        const param = this.props.match.params;

        if (param.id != undefined) {
            this.setState({ patientAccessionId: param.id });
            this.getListData(param.id);
        }
        else {
            this.setState({ loading: false });
        }
    }

    //get detail(for update)
    getListData(pid) {
        var userToken = JSON.parse(localStorage.getItem('Usertoken'));
        let id = 0;
        if (userToken != null) {
            id = (userToken.manufacturerId == null ? 0 : userToken.manufacturerId);
        }
        const apiroute = window.$APIPath;
        const url = apiroute + '/api/ManufacturerActivity/GetByPatientAccessionandManufactureId?id=' + pid + '&&mid=' + id + '';

        axios.get(url, {
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
            }
        })
            .then(result => {
                if (result.data.flag) {
                    let rData = result.data.outdata;
                    //console.log(rData);
                    this.setState({
                        patientId: rData.patientId,
                        patientactivities: rData, title: (rData.length > 0 ? rData[0].title : ""), description: (rData.length > 0 ? rData[0].description : ""), loading: false
                    });
                    //console.log(this.state);
                } else { this.setState({ loading: false }); }
            })
            .catch(error => {
                console.log(error);
                this.setState({
                    // authError: true, errorType: 'danger', error: error.message, 
                    loading: false
                });
                toast.error(error.message)
            });
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    //update title and description
    AddDetail(e) {
        e.preventDefault();
        this.setState({ loading: true });
        let url = "";

        if (this.state.sampleTypeId != "0" && this.state.sampleTypeId != "") {
            var userToken = JSON.parse(localStorage.getItem('Usertoken'));
            let pid = (userToken.manufacturerId == null ? 0 : userToken.manufacturerId);

            const apiroute = window.$APIPath;
            url = apiroute + '/api/ManufacturerActivity/UpdateDetail';
            console.log(this.state.patientactivities);
            let menufactureactivityId = this.state.patientactivities[0].manufacturingActivityId;

            let data = JSON.stringify({
                manufacturerId: parseInt(pid),
                title: this.state.title,
                description: this.state.description,
                patientId: parseInt(this.state.patientId),
                patientAccessionId: parseInt(this.state.patientAccessionId),
                manufacturingActivityId: parseInt(menufactureactivityId),
            })

            console.log(data);
            axios.post(url, data, {
                headers: {
                    'Content-Type': 'application/json; charset=utf-8'
                }
            })
                .then(result => {
                    if (result.data.flag) {
                        this.setState({
                            // authError: true,
                            // errorType: 'success',
                            // error: result.data.message,
                            loading: false
                        }, this.getListData(this.state.patientAccessionId));
                        toast.success(result.data.message)
                    }
                    else {
                        this.setState({
                            // authError: true,
                            // errorType: 'danger',
                            // error: result.data.message,
                            loading: false
                        });
                        toast.error(result.data.message)
                    }
                })
                .catch(error => {
                    this.setState({
                        // authError: true, errorType: 'danger', error: error.message, 
                        loading: false
                    });
                    toast.error(error.message)
                    //this.setState({ authError: true, error: error });
                });
        } else {
            this.setState({ loading: false });
        }
    }

    //update status
    UpdateReadyToMfg(e, id) {
        e.preventDefault();
        this.setState({ loading: true });
        let url = "";

        var userToken = JSON.parse(localStorage.getItem('Usertoken'));
        let pid = (userToken.manufacturerId == null ? 0 : userToken.manufacturerId);

        const apiroute = window.$APIPath;
        url = apiroute + '/api/ManufacturerActivity/UpdateManufacturerActivityReadyToMfg';

        let data = JSON.stringify({
            manufacturerId: parseInt(pid),
            ReadyToMfg: true,
            patientId: parseInt(this.state.patientId),
            patientAccessionId: parseInt(this.state.patientAccessionId),
            manufacturingActivityId: parseInt(id),
        })

        console.log(data);
        axios.post(url, data, {
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
            }
        })
            .then(result => {
                if (result.data.flag) {
                    this.setState({
                        // authError: true,
                        // errorType: 'success',
                        // error: result.data.message,
                        loading: false
                    }, this.getListData(this.state.patientAccessionId));
                    toast.success(result.data.message)
                }
                else {
                    this.setState({
                        // authError: true,
                        // errorType: 'danger',
                        // error: result.data.message,
                        loading: false
                    });
                    toast.error(result.data.message)
                }
            })
            .catch(error => {
                this.setState({
                    // authError: true, errorType: 'danger', error: error.message, 
                    loading: false
                });
                toast.error(error.message)
                //this.setState({ authError: true, error: error });
            });
    }

    UpdateMfgStart(e, id) {
        e.preventDefault();
        this.setState({ loading: true });
        let url = "";

        var userToken = JSON.parse(localStorage.getItem('Usertoken'));
        let pid = (userToken.manufacturerId == null ? 0 : userToken.manufacturerId);

        const apiroute = window.$APIPath;
        url = apiroute + '/api/ManufacturerActivity/UpdateManufacturerActivityMfgStarted';

        let data = JSON.stringify({
            manufacturerId: parseInt(pid),
            MfgStarted: true,
            patientId: parseInt(this.state.patientId),
            patientAccessionId: parseInt(this.state.patientAccessionId),
            manufacturingActivityId: parseInt(id),
        })

        console.log(data);
        axios.post(url, data, {
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
            }
        })
            .then(result => {
                if (result.data.flag) {
                    this.setState({
                        // authError: true,
                        // errorType: 'success',
                        // error: result.data.message,
                        loading: false
                    }, this.getListData(this.state.patientAccessionId));
                    toast.success(result.data.message)
                }
                else {
                    this.setState({
                        // authError: true,
                        // errorType: 'danger',
                        // error: result.data.message,
                        loading: false
                    });
                    toast.error(result.data.message)
                }
            })
            .catch(error => {
                this.setState({
                    // authError: true, errorType: 'danger', error: error.message, 
                    loading: false
                });
                toast.error(error.message)
                //this.setState({ authError: true, error: error });
            });
    }

    UpdateMfgQCPass(e, id) {
        e.preventDefault();
        this.setState({ loading: true });
        let url = "";

        var userToken = JSON.parse(localStorage.getItem('Usertoken'));
        let pid = (userToken.manufacturerId == null ? 0 : userToken.manufacturerId);

        const apiroute = window.$APIPath;
        url = apiroute + '/api/ManufacturerActivity/UpdateManufacturerActivityMfgQcPassed';

        let data = JSON.stringify({
            manufacturerId: parseInt(pid),
            MfgQcPassed: true,
            patientId: parseInt(this.state.patientId),
            patientAccessionId: parseInt(this.state.patientAccessionId),
            manufacturingActivityId: parseInt(id),
        })

        console.log(data);
        axios.post(url, data, {
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
            }
        })
            .then(result => {
                if (result.data.flag) {
                    this.setState({
                        // authError: true,
                        // errorType: 'success',
                        // error: result.data.message,
                        loading: false
                    }, this.getListData(this.state.patientAccessionId));
                    toast.success(result.data.message)
                }
                else {
                    this.setState({
                        // authError: true,
                        // errorType: 'danger',
                        // error: result.data.message,
                        loading: false
                    });
                    toast.error(result.data.message)
                }
            })
            .catch(error => {
                this.setState({
                    // authError: true, errorType: 'danger', error: error.message, 
                    loading: false
                });
                toast.error(error.message)
                //this.setState({ authError: true, error: error });
            });
    }

    UpdateMfgComplete(e, id) {
        e.preventDefault();
        this.setState({ loading: true });
        let url = "";

        var userToken = JSON.parse(localStorage.getItem('Usertoken'));
        let pid = (userToken.manufacturerId == null ? 0 : userToken.manufacturerId);

        const apiroute = window.$APIPath;
        url = apiroute + '/api/ManufacturerActivity/UpdateManufacturerActivityMfgCompleted';

        let data = JSON.stringify({
            manufacturerId: parseInt(pid),
            MfgCompleted: true,
            patientId: parseInt(this.state.patientId),
            patientAccessionId: parseInt(this.state.patientAccessionId),
            manufacturingActivityId: parseInt(id),
        })

        console.log(data);
        axios.post(url, data, {
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
            }
        })
            .then(result => {
                if (result.data.flag) {
                    this.setState({
                        // authError: true,
                        // errorType: 'success',
                        // error: result.data.message,
                        loading: false
                    }, this.getListData(this.state.patientAccessionId));
                    toast.success(result.data.message)
                }
                else {
                    this.setState({
                        // authError: true,
                        // errorType: 'danger',
                        // error: result.data.message,
                        loading: false
                    });
                    toast.error(result.data.message)
                }
            })
            .catch(error => {
                this.setState({
                    // authError: true, errorType: 'danger', error: error.message, 
                    loading: false
                });
                toast.error(error.message)
                //this.setState({ authError: true, error: error });
            });
    }

    UpdateMfgShipped(e, id) {
        e.preventDefault();
        this.setState({ loading: true });
        let url = "";

        var userToken = JSON.parse(localStorage.getItem('Usertoken'));
        let pid = (userToken.manufacturerId == null ? 0 : userToken.manufacturerId);

        const apiroute = window.$APIPath;
        url = apiroute + '/api/ManufacturerActivity/UpdateManufacturerActivityMfgShipped';

        let data = JSON.stringify({
            manufacturerId: parseInt(pid),
            MfgShipped: true,
            patientId: parseInt(this.state.patientId),
            patientAccessionId: parseInt(this.state.patientAccessionId),
            manufacturingActivityId: parseInt(id),
        })

        console.log(data);
        axios.post(url, data, {
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
            }
        })
            .then(result => {
                if (result.data.flag) {
                    this.setState({
                        // authError: true,
                        // errorType: 'success',
                        // error: result.data.message,
                        loading: false
                    }, this.getListData(this.state.patientAccessionId));
                    toast.success(result.data.message)
                }
                else {
                    this.setState({
                        // authError: true,
                        // errorType: 'danger',
                        // error: result.data.message,
                        loading: false
                    });
                    toast.error(result.data.message)
                }
            })
            .catch(error => {
                this.setState({
                    // authError: true, errorType: 'danger', error: error.message, 
                    loading: false
                });
                toast.error(error.message)
                //this.setState({ authError: true, error: error });
            });
    }

    UpdateMfgDelivered(e, id) {
        e.preventDefault();
        this.setState({ loading: true });
        let url = "";

        var userToken = JSON.parse(localStorage.getItem('Usertoken'));
        let pid = (userToken.manufacturerId == null ? 0 : userToken.manufacturerId);

        const apiroute = window.$APIPath;
        url = apiroute + '/api/ManufacturerActivity/UpdateManufacturerActivityMfgDelivered';

        let data = JSON.stringify({
            manufacturerId: parseInt(pid),
            MfgDelivered: true,
            patientId: parseInt(this.state.patientId),
            patientAccessionId: parseInt(this.state.patientAccessionId),
            manufacturingActivityId: parseInt(id),
        })

        console.log(data);
        axios.post(url, data, {
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
            }
        })
            .then(result => {
                if (result.data.flag) {
                    this.setState({
                        // authError: true,
                        // errorType: 'success',
                        // error: result.data.message,
                        loading: false
                    }, this.getListData(this.state.patientAccessionId));
                    toast.success(result.data.message)
                }
                else {
                    this.setState({
                        // authError: true,
                        // errorType: 'danger',
                        // error: result.data.message,
                        loading: false
                    });
                    toast.error(result.data.message)
                }
            })
            .catch(error => {
                this.setState({
                    // authError: true, errorType: 'danger', error: error.message, 
                    loading: false
                });
                toast.error(error.message)
                //this.setState({ authError: true, error: error });
            });
    }

    loading() {
        if (this.state.loading) {
            return <div id="loader-wrapper">
                <div id="loader"></div>
                <div className="loader-section section-left"></div>
                <div className="loader-section section-right"></div>
            </div>;
        }
    }

    render() {
        const { loading, title, description, patientactivities, error, errorType, authError } = this.state;

        return (
            <React.Fragment>
                <div className="kt-grid kt-grid--hor kt-grid--root">
                    <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver kt-page">
                        <button className="kt-aside-close " id="kt_aside_close_btn"><i className="la la-close"></i></button>
                        <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor kt-wrapper" id="kt_wrapper">
                            <div className="kt-content  kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor" id="kt_content">
                                <div className="kt-subheader   kt-grid__item" id="kt_subheader">
                                    <div className="kt-container  kt-container--fluid ">
                                        <div className="kt-subheader__main">
                                            <h3>
                                                <Link to="/manufacturer/dashboard" className="kt-subheader__title">
                                                    Dashboard                       
                                                </Link>
                                            </h3>
                                            <span className="kt-subheader__separator kt-hidden"></span>
                                            <div className="kt-subheader__breadcrumbs">
                                                <Link className="kt-subheader__breadcrumbs-home"><i className="flaticon2-arrow"></i></Link>
                                                {/*<span className="kt-subheader__breadcrumbs-separator"></span>*/}
                                                <Link to="#" className="kt-subheader__breadcrumbs-link">
                                                    Analysis                       </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
                                    <div className="kt-portlet">
                                        {/* {authError ?
                                            <div>
                                                <div className={"alert alert-" + errorType + " alert-dismissible"} role="alert">
                                                    <div className="alert-text">{error}</div>
                                                    <div className="alert-close">
                                                        <i className="flaticon2-cross kt-icon-sm" data-dismiss="alert"></i>
                                                    </div>
                                                </div>
                                            </div>
                                            : null} */}
                                        <div className="kt-portlet__body">
                                            <table className="table table-striped- table-bordered table-hover table-checkable" id="kt_table_1">
                                                <thead>
                                                    <tr>
                                                        <th>Patient Accession Number</th>
                                                        {/*<th>Lab Name</th>
                                                        <th>Lab Email, Mobile No <br /> Address</th>
                                                        <th>Analysis Description</th>*/}
                                                        <th>Change Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                    // !loading ? (
                                                        //standards.map(function (data,i) {
                                                        patientactivities.length > 0 ? (
                                                            patientactivities
                                                                .map((data, i) => {
                                                                    return (<tr key={i}>
                                                                        <td>{data.patientAccessionNo.replace(/-/g, "")}</td>
                                                                        {/*<td>{data.manufacturerName}</td>
                                                                        <td>{data.manufacturerEmail + ", " + data.manufacturerPhone}<br />{data.manufacturerAddress}</td>
                                                                        <td>{data.description}</td>*/}
                                                                        <td>
                                                                            <span className="kt-shape-bg-color-3" style={{ "padding": "4px", "color": "#fff" }}>{data.currentStatus}</span>
                                                                            <br />
                                                                            {(data.currentStatus == "Design delivered" ?
                                                                                <a className="btn btn-outline-info btn-pd-mt" onClick={e => this.UpdateReadyToMfg(e, data.manufacturingActivityId)}>Ready to Manufacture</a>
                                                                                :
                                                                                (data.currentStatus == "Ready to Manufacture" ?
                                                                                    <React.Fragment>
                                                                                        <a className="btn btn-outline-info btn-pd-mt" onClick={e => this.UpdateMfgStart(e, data.manufacturingActivityId)}>Manufacturing Started</a>
                                                                                    </React.Fragment>
                                                                                    :
                                                                                    (data.currentStatus == "Manufacturing Started" ?
                                                                                        <a className="btn btn-outline-info btn-pd-mt" onClick={e => this.UpdateMfgQCPass(e, data.manufacturingActivityId)}>Manufacturing QC Passed</a>
                                                                                        :
                                                                                        (data.currentStatus == "Manufacturing QC Passed" ?
                                                                                            <a className="btn btn-outline-info btn-pd-mt" onClick={e => this.UpdateMfgComplete(e, data.manufacturingActivityId)}>Manufacturing Completed</a>
                                                                                            :
                                                                                            (data.currentStatus == "Manufacturing Completed" ?
                                                                                                <a className="btn btn-outline-info btn-pd-mt" onClick={e => this.UpdateMfgShipped(e, data.manufacturingActivityId)}>Shipped</a>
                                                                                                :
                                                                                                (data.currentStatus == "Shipped" ?
                                                                                                    <a className="btn btn-outline-info btn-pd-mt" onClick={e => this.UpdateMfgDelivered(e, data.manufacturingActivityId)}>Delivered</a>
                                                                                                    :
                                                                                                    (null)
                                                                                                )
                                                                                            )
                                                                                        )
                                                                                    )
                                                                                )
                                                                            )}
                                                                        </td>
                                                                    </tr>);
                                                                })
                                                        ) : (
                                                                <tr>
                                                                    <td colSpan="5" className="tdCenter">No activities found...</td></tr>
                                                            // )) : (
                                                            // <tr>
                                                            //     <td colSpan="5" className="tdCenter">Loading...</td></tr>
                                                        )}
                                                </tbody>
                                            </table>
                                            <hr />

                                            <div>
                                                <div className="form-group row my-4">
                                                    <div className="col-md-6">
                                                        <label className="col-12 col-form-label">Title</label>
                                                        <div className="col-12">
                                                            <Input className="form-control here" type="text" maxLength="100" tabIndex="1" placeholder="Enter title" name="title" value={title} onChange={this.handleInputChange.bind(this)} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label className="col-12 col-form-label">Description</label>
                                                        <div className="col-12">
                                                            <Input className="form-control here" type="textarea" tabIndex="2" placeholder="Enter description" name="description" value={description} onChange={this.handleInputChange.bind(this)} />
                                                        </div>
                                                    </div>
                                                </div>
                                                {loading ?
                                                    <button tabIndex="3" type="button" className="btn btn-primary kt-spinner kt-spinner--right kt-spinner--sm kt-spinner--light" disabled="disabled">Submit</button>
                                                    :
                                                    <button tabIndex="3" type="button" onClick={this.AddDetail.bind(this)} className="btn btn-primary">Submit</button>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {this.loading()}
                </div>
            </React.Fragment >
        );
    }
}
